import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { onMounted, ref } from "vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'IntersectionObservableVue',
  props: {
    observer: {},
    isVisible: {
      type: Boolean
    }
  },
  setup(__props) {
    var props = __props;
    var root = ref(null);
    onMounted(() => {
      if (!props.observer || !root.value) return;
      //Now we are telling the observer to watch this component!
      props.observer.observe(root.value);
    });
    return (_ctx, _cache) => {
      return !_ctx.isVisible ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        ref_key: "root",
        ref: root,
        class: _normalizeClass(_ctx.$attrs['root-classes'])
      }, [_renderSlot(_ctx.$slots, "observable")], 2 /* CLASS */)) : _renderSlot(_ctx.$slots, "observable", {
        key: 1
      });
    };
  }
});